@use '@design/design-tokens/typography/typography' as *;

.chatCardWrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px;

  &:hover {
    background-color: var(--surface-hover);
  }
}

.title {
  margin: 0;
  @include typography-v2-title-base;
}

.summary {
  @include typography-v2-body-sm;
  color: var(--text-soft);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.timestampWrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--text-soft);
}

.mark {
  color: var(--text-primary);
  background-color: unset;
}
